import React, { useState, useEffect } from 'react';
import { Trash2 } from 'lucide-react';
import { adminStatsService } from '../../../services/adminStatsService';
import { useSeasonContext } from '../../../context/SeasonContext';

const WhatsNextItemBlock = ({ block, onUpdate, onDelete }) => {
  const [teams, setTeams] = useState([]);
  const { selectedSeason } = useSeasonContext();

  useEffect(() => {
    if (selectedSeason?.id) {
      fetchTeams();
    }
  }, [selectedSeason?.id]);

  const fetchTeams = async () => {
    try {
      const playerList = await adminStatsService.getPlayersForSeason(selectedSeason.id);
      const uniqueTeams = [...new Set(playerList.map(p => p.team).filter(Boolean))].sort();
      setTeams(uniqueTeams);
    } catch (error) {
      console.error('Error fetching teams:', error);
    }
  };

  return (
    <div className="block-item whatsnext-block">
      <div className="block-header">
        <span>What's Next</span>
        <button
          type="button"
          className="btn-icon-small delete"
          onClick={() => onDelete(block.id)}
        >
          <Trash2 size={16} />
        </button>
      </div>
      <select
        value={block.team || ''}
        onChange={(e) => onUpdate(block.id, { team: e.target.value })}
        className="field-select"
      >
        <option value="">Select team</option>
        {teams.map((team) => (
          <option key={team} value={team}>
            {team}
          </option>
        ))}
      </select>
      <input
        type="text"
        placeholder="Opponent"
        value={block.opponent || ''}
        onChange={(e) => onUpdate(block.id, { opponent: e.target.value })}
        className="field-input"
      />
      <input
        type="date"
        placeholder="Date"
        value={block.date || ''}
        onChange={(e) => onUpdate(block.id, { date: e.target.value })}
        className="field-input"
      />
      <textarea
        placeholder="Details..."
        value={block.details || ''}
        onChange={(e) => onUpdate(block.id, { details: e.target.value })}
        className="field-textarea"
      />
    </div>
  );
};

export default WhatsNextItemBlock;
